import { Link } from "react-router-dom";
import InfoLayout from "@/components/InfoLayout";
import InlineCTA from "@/components/InlineCTA";
import { INSURANCES, SITE_URL } from "@/seo/data";
import { ArrowRight } from "@phosphor-icons/react";

export default function VersicherungenHub() {
  const title = "Autoglas Versicherung & Teilkasko | Servus Autoglas";
  const description = "Steinschlag, Scheibentausch und Teilkasko: Erfahren Sie, wann eine Selbstbeteiligung anfällt und wie Servus Autoglas bei der Abwicklung hilft.";
  const canonical = `${SITE_URL}/versicherungen`;

  return (
    <InfoLayout title={title} description={description} canonical={canonical}>
      <h1>Autoglas und Versicherung — wir helfen bei der Abwicklung</h1>
      <p className="lead">
        Ein Steinschlag oder eine beschädigte Windschutzscheibe ist ärgerlich. Gut zu wissen: Viele
        Teilkaskoversicherungen übernehmen die Kosten einer fachgerechten Steinschlagreparatur unter
        bestimmten Voraussetzungen ohne Selbstbeteiligung. Ist ein Austausch der Windschutzscheibe
        erforderlich, kann je nach Versicherungsvertrag eine vereinbarte Selbstbeteiligung anfallen.
        Welche Kosten Ihre Versicherung übernimmt, hängt von Ihrem Tarif, den Vertragsbedingungen und dem
        konkreten Schadenfall ab. Wir unterstützen Sie bei der Klärung der Versicherungsabwicklung und
        informieren Sie transparent über mögliche Eigenkosten.
      </p>

      <h2>Welche Versicherungen wir direkt abwickeln</h2>
      <div className="not-prose grid sm:grid-cols-2 gap-3 my-6">
        {INSURANCES.map((i) => (
          <Link
            key={i.slug}
            to={`/versicherung/${i.slug}`}
            className="block bg-white rounded-xl border border-slate-200 hover:border-blue-400 hover:shadow-sm p-4 transition-all"
            data-testid={`insurance-link-${i.slug}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="font-bold text-slate-900">{i.name}</div>
                <div className="text-xs text-slate-500 mt-0.5 leading-snug">{i.note}</div>
              </div>
              <ArrowRight size={18} className="text-blue-600 flex-shrink-0" />
            </div>
          </Link>
        ))}
      </div>

      <h2>So funktioniert die Direktabwicklung</h2>
      <ol>
        <li><strong>Sie melden den Schaden online.</strong> Fahrzeugschein, Versicherungsschein und Fotos werden hochgeladen — unsere KI liest Fahrzeug- und Versicherungsdaten automatisch aus.</li>
        <li><strong>Sie wählen Ihre Versicherung</strong> und tragen die vereinbarte Selbstbeteiligung ein (steht in Ihrem Versicherungsschein).</li>
        <li><strong>Sie unterschreiben digital die Abtretungserklärung.</strong> Damit dürfen wir mit der Versicherung direkt korrespondieren.</li>
        <li><strong>Wir holen die Schadennummer ein</strong> und reichen alle Unterlagen elektronisch ein.</li>
        <li><strong>Wir reparieren oder tauschen die Scheibe</strong> binnen 24 Stunden in Mannheim oder Umgebung.</li>
        <li><strong>Die Versicherung zahlt direkt an uns.</strong> Sie zahlen nur die ggf. fällige Selbstbeteiligung — online oder vor Ort.</li>
      </ol>

      <h2>Teilkasko, Vollkasko oder keine Kasko?</h2>
      <p>
        <strong>Teilkasko:</strong> Glasschäden sind regelmäßig mitversichert — Steinschlagreparatur sowie
        Komplettaustausch von Front-, Seiten- und Heckscheibe. Reparatur meist ohne Selbstbeteiligung, Tausch
        mit der vertraglich vereinbarten Selbstbeteiligung (häufig 150 €). Maßgeblich sind immer Ihre
        Versicherungsbedingungen und der konkrete Schadenfall.
      </p>
      <h3>Übernimmt die Versicherung auch die ADAS-Kalibrierung?</h3>
      <p>
        Wenn nach einem versicherten Windschutzscheibentausch eine ADAS-Kalibrierung nach Herstellervorgaben
        erforderlich ist, können die Kosten im Rahmen der Schadenregulierung berücksichtigt werden. Ob eine
        Kostenübernahme erfolgt, hängt von den Vertragsbedingungen und der Prüfung des konkreten Schadenfalls
        ab. Eine pauschale Kostenübernahme durch jede Versicherung kann nicht zugesagt werden.
      </p>
      <p>
        <strong>Vollkasko:</strong> Deckt zusätzlich selbstverschuldete Schäden, Vandalismus und Schäden am
        Glasdach. Schadenfreiheitsrabatt bleibt bei reiner Glasreparatur erhalten.
      </p>
      <p>
        <strong>Keine Kasko:</strong> Sie zahlen selbst — wir bieten Ihnen einen{" "}
        <Link to="/selbstzahler">Selbstzahler-Flow</Link> mit KI-Preisschätzung und 25 % Anzahlung zur
        Terminsicherung.
      </p>

      <InlineCTA />
    </InfoLayout>
  );
}
